import { map } from 'rxjs/operators';
import type { Currency } from 'v2/interfaces/currency';

import apiService from './api';
import type { ApiService } from './api';

class CurrencyService {
  constructor(private apiService: ApiService) {}

  public list(): Promise<Currency[]> {
    return this.apiService
      .get('currencies')
      .pipe(map(response => response.data))
      .toPromise();
  }
}

const currencyService = new CurrencyService(apiService);
export default currencyService;
